import { isDevMode } from '@angular/core';

declare global {
    interface Window {
        bizcareDesktop?: {
            isElectron?: boolean;
            getVersion?: () => Promise<string>;
            getPlatform?: () => Promise<string>;
        };
    }
}

/** True when running inside the BizCare Electron shell. */
export function isElectronApp(): boolean {
    if (typeof window === 'undefined') {
        return false;
    }

    return window.bizcareDesktop?.isElectron === true;
}

export function isLocalDevHost(): boolean {
    if (typeof window === 'undefined') {
        return isDevMode();
    }

    return location.hostname === 'localhost' || location.hostname === '127.0.0.1';
}

/** Angular ngsw handles production caching; disabled in Electron (custom protocol / no SW). */
export function useAngularNgsw(): boolean {
    return !isDevMode() && !isElectronApp();
}

const LOCAL_PWA_DEV_KEY = 'bizcare_pwa_dev';

/** Opt-in on localhost via ?pwa=1 (persisted) or ?pwa=0 to disable. */
export function isLocalPwaDevEnabled(): boolean {
    if (typeof window === 'undefined' || !isLocalDevHost()) {
        return false;
    }

    const params = new URLSearchParams(location.search);
    if (params.get('pwa') === '0') {
        localStorage.removeItem(LOCAL_PWA_DEV_KEY);
        return false;
    }

    if (params.get('pwa') === '1') {
        localStorage.setItem(LOCAL_PWA_DEV_KEY, '1');
        return true;
    }

    return localStorage.getItem(LOCAL_PWA_DEV_KEY) === '1';
}
